import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import Img from '../../../components/Img';

import styles from './dayPlanner.scss';
import { clearVirtualDraw } from '../../../actions/day-planner-actions';
import Popup from '../../../components/Popup';
import Match from './Match';
import { isMatchScheduled } from '../../../utils/dayPlanner';

const VirtualDrawListItem = (props) => {
    const {
        className,
        draw,
        primaryView,
        isDrawLevel,
        'data-testid': dataTestId,
    } = props;

    const { id, name, drawColor } = draw;

    const [isOpen, setIsOpen] = useState(false);
    const [showConfirmDeleteVirtualDraw, setShowConfirmDeleteVirtualDraw] = useState(false);

    const dispatch = useDispatch();

    const onClickDelete = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        setShowConfirmDeleteVirtualDraw(true);
    };

    const onConfirmDelete = () => {
        dispatch(clearVirtualDraw(id));
        onCloseConfirmDelete();
    };

    const onCloseConfirmDelete = () => {
        setShowConfirmDeleteVirtualDraw(false);
    };

    const onClickItem = () => {
        setIsOpen(!isOpen);
    };

    const unScheduledMatches = !isDrawLevel
        ? draw.matches.filter(match => !isMatchScheduled(match))
        : [];

    return (
        <>
            <div className={`${styles.drawListItem} ${className || ''}`} data-testid={dataTestId}>
                <div
                    className={`d-flex align-items-center ${styles.parentSection}`}
                    onClick={onClickItem}
                    data-testid={dataTestId && `${dataTestId}.section`}
                >
                    <div className={styles.arrow}>
                        {isOpen && (
                            <i className={`fas fa-solid fa-caret-down`} />
                        )}
                        {!isOpen && (
                            <i className={`fas fa-solid fa-caret-right`} />
                        )}
                    </div>
                    <div className="flex-1 mw0 ml4 mr4 fw600" data-testid={dataTestId && `${dataTestId}.name`}>
                        {name}
                    </div>
                    {!isDrawLevel && drawColor && (
                        <div
                            className={`${styles.sample}`}
                            style={{ backgroundColor: draw.drawColor }}
                        />
                    )}
                    {isDrawLevel && (
                        <button
                            className={`btn ${styles.drawSettings} p0 mr4`}
                            type="button"
                            onClick={onClickDelete}
                            data-testid={dataTestId && `${dataTestId}.delete-btn`}
                        >
                            <Img src={'/img/v3/icons/icon-trash-red.svg'} />
                        </button>
                    )}
                </div>
                {isOpen && (
                    <div className={`d-flex align-items-start ${styles.childSection}`}>
                        <div className={`${styles.arrow}`} />
                        <div className="flex-1 mw0 ml4">
                            {isDrawLevel && draw.groups.map((group) => {
                                return (
                                    <VirtualDrawListItem
                                        key={`virtual-draw-group-${group.id}`}
                                        draw={group}
                                        primaryView={primaryView}
                                        className={styles.childDraw}
                                        isDrawLevel={false}
                                        data-testid={dataTestId && `${dataTestId}.group-${group.id}`}
                                    />
                                );
                            })}
                            {!isDrawLevel && (
                                <div className={styles.drawMatches}>
                                    {unScheduledMatches.map((match) => {
                                        return (
                                            <Match
                                                key={`match-${match.id}`}
                                                match={match}
                                                primaryView={primaryView}
                                                data-testid={dataTestId && `${dataTestId}.match-${match.id}`}
                                            />
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {showConfirmDeleteVirtualDraw && (
                <Popup
                    className="popup-sm"
                    popUpClassName={styles.confirmPopup}
                    onCloseClick={onCloseConfirmDelete}
                    closeOnClickOutside={false}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        scrollable: false,
                        showCloseIcon: false,
                    }}
                    data-testid={`modal.day-planner.draw-${id}.confirm-delete`}
                >
                    <p className={styles.description} data-testid={`modal.day-planner.draw-${id}.confirm-delete.description`}>
                        Do you want to delete virtual draw?
                    </p>
                    <div className="d-flex mt16">
                        <button
                            className="btn btn-default flex-1 mr8"
                            type="button"
                            onClick={onCloseConfirmDelete}
                            data-testid={`modal.day-planner.draw-${id}.confirm-delete.cancel-btn`}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary flex-1"
                            type="button"
                            onClick={onConfirmDelete}
                            data-testid={`modal.day-planner.draw-${id}.confirm-delete.confirm-btn`}
                        >
                            Delete
                        </button>
                    </div>
                </Popup>
            )}
        </>
    );
};

VirtualDrawListItem.propTypes = {
    primaryView: PropTypes.string.isRequired,
    draw: PropTypes.objectOf(any),
    className: PropTypes.string,
    isDrawLevel: PropTypes.bool,
    'data-testid': PropTypes.string,
};

VirtualDrawListItem.defaultProps = {
    draw: {},
    className: null,
    isDrawLevel: false,
    'data-testid': undefined,
};

export default VirtualDrawListItem;
